import React from 'react';
import Header from './Header';

interface Feature {
  id: string;
  name: string;
  route: string;
  icon: string;
  description: string;
}

interface AppLayoutProps {
  children: React.ReactNode;
  features: Feature[];
  title?: string;
  sidebar?: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, features, title, sidebar }) => {
  return (
    <div className="app-container">
      {/* Pass features to Header for navigation */}
      <Header title={title} features={features} />
      
      {/* Optional sidebar - only rendered if provided */}
      {sidebar}
      
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default AppLayout;